import React from "react";
import ThemeToggleButton from "@components-shared/ThemeToggleButton";
import { THEME_SETTINGS } from "@theme-settings";

export default function HeaderThemeToggle() {
	if (!THEME_SETTINGS.isThemeSelectorEnabled) {
		return null;
	}
	return <ThemeToggleButton />;
}
